const resizeTo1080p = ({
  file,
  maxLongSide = 1920, // 1080p landscape = 1920x1080
  quality = 0.75,
  mimeType = 'image/jpeg',
}) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      let { width, height } = img;

      // Detect longest side (for portrait & landscape)
      const longSide = Math.max(width, height);

      // If already <= 1080p, return original
      if (longSide <= maxLongSide) {
        URL.revokeObjectURL(objectUrl);
        return resolve(file);
      }

      const scale = maxLongSide / longSide;
      const newWidth = Math.round(width * scale);
      const newHeight = Math.round(height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;

      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      canvas.toBlob(
        blob => {
          if (!blob) return reject(new Error('Canvas resize failed'));

          const resizedFile = new File([blob], file.name, {
            type: mimeType,
            lastModified: Date.now(),
          });

          resolve(resizedFile);
          URL.revokeObjectURL(objectUrl);
        },
        mimeType,
        quality
      );
    };

    img.onerror = reject;
    img.src = objectUrl;
  });
};

export default resizeTo1080p;
